import User from '../models/User';
import Template from '../models/Template';
import Draft from '../models/Draft';
import DraftSessions from '../models/DraftSessions';

import _ from 'lodash';
import faker from 'faker';
import PageContainer from './PageContainer';
import mockTemplates from './__mocks__/templates.json';
import session from '../models/Session';
import Story from '../models/Story';
import socket from '../libraries/socket';


export default class WrapUpContainer extends PageContainer {
  state = {
    allowedDisplayedCardToParticipant: [],
    template: null,
    sessionNumber: 1,
    participants: [],
    createdBy: null,
    notes: [],
    note: '',
    value: '',
    isRemovedFromLastSession: false,
    modal: false,
    draft: null,
    draftSessions: null,
    story: null,
  }

  options = {
    getFromSession: ['template', 'draft', 'story'],
    defaultState: {
      template: Template.mock(),
      draft: Draft.mock(),
      participants: _.range(3).map(i => User.mock()),
      createdBy: User.mock(),
      draftSessions: DraftSessions.mock({type: "completed"})
    },
    flags: [{
      name: 'isLoaded',
      check: () => true,
    }],
  }

  async setup() {
    await this.subscribeToSession();

    // if (!this.state.draftSessions) {
    //   await this.setState(this.options.defaultState);
    // }

    // session.set('story', new Story({
    //   draft: this.state.draft, 
    //   template: this.state.template,
    // }));

    // this.setState({
    //   story: session.get('story')
    // })\
    socket.syncWithParticipants();
  }

  destroy() {
    this.unsubscribeAll();
  }

  toggleModal = () => {
    this.setState({
      modal: !this.state.modal,
    });
  }

  removeFromPreviousBtn = (id) => {
    this.toggleModal();
    if (this.state.participants.findIndex(participant => participant._id === id)) {
      this.setState({
        isRemovedFromLastSession: true,
      }, ()=>console.log('isRemovedFromLastSession', this.state.isRemovedFromLastSession));
    }
  }

  handleOnChange = (output) => (event) => {
    let val = event; 

    if (event.target) {
      val = event.target.value; 
    }

    let key = _.snakeCase(output.slug); 

    let changes = {
      [key]: val
    };

    if (/story_title|story_blurb/i.test(key)) {
      changes[key.replace('story_', '')] = val; 
    }

    session.set({
      story: session.get('story').set(changes)
    });

    // console.log('Setting story val', key, val, event, output, session.get('story').toObject());

    console.log('wrapUpContainer:handleOnChange', event, changes, session.get('story').toObject());

   if (this.state.draft.createdBy !== session.get('user')._id) {
      socket.syncChangesWithParticipants({
        [_.snakeCase(output.slug)]: val
      }); 
    } 
  
    // console.log('valie', value);
    // this.setState({
    //   // note: value,
    // });
  }

  constructor(props) {
    super(props);
    this.getPropsFromSession(this.options.getFromSession);
    this.setupFlags(this.options.flags);
  }
}




// WEBPACK FOOTER //
// ./src/containers/WrapUpContainer.js